import { withTheme } from '@mui/styles';
import styled from 'styled-components';

const OurServiceSectionStyle = withTheme(styled.div`
  padding: 80px 0px;

  .primary-dark-color {
    color: ${(props: any) => props.theme.palette.primary.dark} !important;
  }

  .secondary-light-color {
    color: ${(props: any) => props.theme.palette.secondary.light} !important;
  }

  .skl-for-business-button-group {
    margin: 14px 0px 40px 0px;
  }

  .skl-for-business-content {
    background-color: #f5f5f5;
    position: relative;
    height: 370px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;

    .skilllane-plus-title {
      margin: 45px 0px 25px 0px;
      img {
        width: 272px;
      }
    }
    .tuxsa-title {
      margin: 45px 0px 25px 0px;
      img {
        width: 176px;
      }
    }
    .onward-title {
      margin-top: 20px;
      img {
        width: 176px;
      }
    }
    .cpd-title {
      margin: 45px 0px 25px 0px;
      img {
        width: 176px;
      }
    }
  }

  .onward-expand-subtitle {
    margin-top: 5px;

    p {
      font-size: 16px;
      line-height: 16px;
      color: ${(props: any) => props.theme.palette.secondary.light};
    }
  }

  ${(props: any) => props.theme.breakpoints.down('lg')} {
    .skl-for-business-button-group {
      text-align: center;
    }

    .skl-for-business-content {
      height: 700px;
      align-items: flex-start;

      .content-container {
        padding: 0px 50px;
      }

      .tuxsa-title {
        img {
          width: 200px;
          height: 40px;
        }
      }

      .onward-title {
        margin: 45px 0px 25px 0px;

        img {
          width: 230px;
          height: 50px;
        }
      }

      .cpd-title {
        img {
          height: 55px;
        }
      }

      .skilllane-plus-title {
        margin: 25px 0px 10px 0px;

        img {
          width: 250px;
          height: 80px;
        }
      }
    }
  }

  ${(props: any) => props.theme.breakpoints.down('sm')} {
    .skl-for-business-button-group {
      button {
        font-size: 16px;
        min-width: 62px;
        padding: 0px 5px;
      }
    }

    .skl-for-business-content {
      align-items: flex-start;
      height: 600px;

      .tuxsa-title {
        margin: 30px 0px 15px 0px;
        img {
          width: 150px;
          height: 50px;
        }
      }

      .onward-title {
        margin: 30px 0px 15px 0px;
        img {
          width: 150px;
          height: 50px;
        }
      }

      .cpd-title {
        margin: 30px 0px 15px 0px;
        img {
          width: 150px;
          height: 50px;
        }
      }

      .skilllane-plus-title {
        margin: 20px 0px 10px 0px;
        img {
          width: 180px;
          height: 60px;
        }
      }

      .content-container {
        padding: 0px 16px;
      }
    }

    .onward-title {
      margin-top: 00px;
      img {
        width: 176px;
      }
    }
  }
`);

export default OurServiceSectionStyle;
